import { Injectable } from '@angular/core';
import { BundleProductsCode } from '../utils/enums/bundle-products.enum';
import { IAddOnProductsModel, ILicenseBundle, LicenseCategoryEnum } from '../utils/interfaces/products-model';
import { AccountService } from './auth/account.service';
import { AddOnProducts } from '../utils/enums/add-on-products.enum';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {
  constructor(
    private readonly accountService: AccountService
  ) { }

  async isExamModeAccessible(): Promise<boolean> {
    // get the accountInfo
    const accountInfo = await this.accountService.getAccountInfo();

    // get the available add-on products for the first licenseId
    if (accountInfo) {
      const result = await this.accountService.getLicenses(accountInfo.licenseIds[0]);
      const bundle = result.bundle;

      const hasProduct = this.bundleHasExamProducts(bundle);
      const hasAddOn = this.checkWolandAddons(result.addOnProducts);
      const correctCategory = this.checkCategory(result.category);

      return (hasProduct || hasAddOn) && correctCategory;
    }

    return false;
  }

  private bundleHasExamProducts(bundle: ILicenseBundle): boolean {
    return bundle.products.map(p => p.productCode)
      .some(p => p === BundleProductsCode.wolandCore || p === BundleProductsCode.wolandAdvanced);
  }

  private checkCategory(category: LicenseCategoryEnum): boolean {
    return category !== LicenseCategoryEnum.Individual;
  }

  private checkWolandAddons(addOns: IAddOnProductsModel[]): boolean {
    return addOns.find(product => product.productCode === AddOnProducts.wolandCore
      || product.productCode === AddOnProducts.wolandAdvanced) !== undefined;
  }
}
